// Resolve propriedades aninhadas de forma segura, sem eval()
// Ex: resolveProp(item, 'obra.titulo') === item?.obra?.titulo
function resolveProp(obj, path) {
  return path.split('.').reduce((acc, key) => acc?.[key], obj)
}

const fetchService = async filter => {
  const { folder, file, relationship } = filter.service
  const http = await import(`../services/http/${folder}/${file}.js`).then(
    m => m.default
  )

  return relationship
    ? hasRelationship(http, relationship, filter)
    : notHasRelationship(http, filter)
}

const hasRelationship = async (http, relationship, filter) => {
  const {
    data: { data }
  } = await http()
    [relationship]()
    .show({ per_page: -1, ...filter?.query })

  return data?.map(item => ({
    ...item,
    [`${filter.itemValue}`]: item[filter.itemValue],
    [`${filter.listLabel}`]: resolveProp(item, filter.itemText)
  }))
}

const notHasRelationship = async (http, filter) => {
  const {
    data: { data }
  } = await http().show({ per_page: -1, ...filter?.query })

  return data.map(item => ({
    ...item,
    [`${filter.itemValue}`]: item[filter.itemValue],
    [`${filter.listLabel}`]: resolveProp(item, filter.itemText)
  }))
}

export default fetchService
